function book_Reducer(state = [], action) {
    switch (action.type) {
        case 'BOOK/SET':            
            return action.book;
        case 'BOOK/CLEAR':
            return null;
        default:
            return state;
    }
}

export default book_Reducer;
